import React from 'react';
import PageIntro from '../components/PageIntro';
import { usePageMeta, SITE_NAME } from '../lib/usePageMeta';

const disclaimerSections = [
  {
    title: 'Educational purpose',
    body: `Definitionofthe.com is an educational and dictionary-based platform created to help students, teachers, professionals, non-professionals, and learners worldwide improve their understanding of words, meanings, language concepts, and educational content. While we strive to provide accurate, updated, and reliable information, we make no guarantees regarding the completeness, reliability, suitability, or accuracy of any information published on this website.`,
  },
  {
    title: 'No professional advice',
    body: `The content available on this website is intended solely for educational and informational purposes and should not be considered professional, legal, academic, financial, medical, or career advice. Users are encouraged to verify information independently and consult qualified professionals when necessary.`,
  },
  {
    title: 'Accuracy of information',
    body: `We continuously work to keep the content accurate and up to date. However, language, meanings, interpretations, and educational materials may change over time. Definitionofthe.com shall not be held responsible for any errors, omissions, or inaccuracies in the content. Any action you take based on the information found on this website is strictly at your own risk.`,
  },
  {
    title: 'External links',
    body: `Our website may contain links to external websites for additional references or resources. While we aim to provide links to trustworthy and ethical websites, we have no control over the content, policies, or nature of these third-party websites. The inclusion of any external links does not imply endorsement or recommendation of all content found on those sites.`,
  },
  {
    title: 'Limitation of liability',
    body: `Under no circumstances shall Definitionofthe.com or its owners, contributors, or affiliates be liable for any direct, indirect, incidental, consequential, or special damages arising from the use of this website or reliance on any information provided herein.`,
  },
  {
    title: 'Copyright and fair use',
    body: `All content published on Definitionofthe.com, including text, graphics, logos, and educational materials, is protected by applicable copyright laws unless otherwise stated. Dictionary definitions come from Wiktionary and are shared under their own licence, named on each word page. Unauthorized reproduction, distribution, or copying of website content without permission is prohibited.`,
  },
  {
    title: 'Updates to this disclaimer',
    body: `We reserve the right to update, amend, or make changes to this Disclaimer at any time without prior notice. Any updates will be posted on this page.`,
  },
];

const Disclaimer = () => {
  usePageMeta(
    `Disclaimer | ${SITE_NAME}`,
    'The information on Definitionofthe.com is for general educational purposes. Read the terms that apply to using it.'
  );

  return (
    <div className="wrap pt-12 md:pt-16">
      <PageIntro title="Disclaimer">
        The information on this website is for general educational and informational purposes only. By using it,
        you agree to the terms below.
      </PageIntro>

      <div className="mt-12 max-w-2xl">
        {disclaimerSections.map((section) => (
          <section key={section.title} className="border-t border-rule py-8">
            <h2 className="font-serif text-2xl font-semibold">{section.title}</h2>
            <p className="mt-3 leading-relaxed">{section.body}</p>
          </section>
        ))}

        <section className="border-t border-rule py-8">
          <h2 className="font-serif text-2xl font-semibold">Contact us</h2>
          <p className="mt-3 leading-relaxed">If you have any questions about this Disclaimer, you can contact us at:</p>
          <ul className="mt-3 space-y-1.5">
            <li><a href="mailto:gajendrajha7@gmail.com" className="text-link">gajendrajha7@gmail.com</a></li>
            <li><a href="mailto:megajendrajha@gmail.com" className="text-link">megajendrajha@gmail.com</a></li>
          </ul>
        </section>

        <p className="border-t border-rule pt-8 font-serif text-lg">
          By using this website, you consent to this Disclaimer and agree to its terms.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
